module.exports = __webpack_public_path__ + "icon_config.dd444.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_config.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_config.svg
// module chunks = main